<template>
    <section class="reasons">
        <div class="reasons__content container">
          <div class="reasons__header">
            <h1 class="reasons__title --fade-in-right" data-vertical-ivp-class="--animate">Reasons to Invest</h1>
          </div>
          <div class="reasons__columns">
            <div class="reasons__list --fade-in-right" data-vertical-ivp-class="--animate">
                <li>
                    <b>A Growing Industry</b><br>
                    The global extended warranty market was valued at $121.5 billion in 2021 
                    and is expected to grow at a CAGR of 6.7%, reaching $182.3 billion by 2027.
                </li>  
                <li>
                    <b>Confidence and security</b><br>
                    Extended warranties give consumers the option to protect their 
                    valuable purchases at relatively low upfront cost, making them an attractive option 
                    for higher ticket items such as electronics. 
                </li>
                <li>
                    <b>Experienced leadership</b><br>
                    The team at MHHC is made up of industry veterans and leaders 
                    with the skills and qualifications to continue to innovate and excel as 
                    the extended warranty industry moves online.
                </li>
                <li>
                    <b>Ecommerce expansion</b><br>
                    With its new ecommerce subsidiary ONBLi, MHHC is investing back 
                    into the business and bringing extended warranty protection to 
                    the world of ecommerce in a big way.
                </li>
                <li>
                    <b>Untapped market</b><br>
                    Many consumers think of extended warranties as something 
                    that’s only available with brick and mortar purchases, but MHHC’s 
                    is betting big on plans to streamline the offering of this kind of 
                    protection to the booming $5.5 trillion ecommerce market.
                </li>
                <li>
                    <b>Solid financials</b><br>
                    MHHC prides itself as a fully audited and reporting company. 
                    The company believes in reinvesting back into the business, 
                    and recently issued a special stock dividend to existing shareholders. 
                    Management also recently retired 30,000,000 shares, further improving 
                    the company’s share structure.
                </li>
                <li>
                    <b>Now Trading on OTCQB</b><br>
                    The company now trades on OTCQB. MHHC is confident that 
                    this change will bring increased transparency, heightened 
                    reporting standards, and greater liquidity and awareness for shareholders.
                </li>            
            </div>
            <div class="reasons__image --fade-in-left" data-vertical-ivp-class="--animate">
              <div class="reasons__image--container">
                <img class="--desktop" src="../assets/reasons/reasons_to_invest.png">
              </div>
              <div class="reasons__quote">
                <p>
                  “MHHC results are achieved through sensible, expedient, and proactive understanding and protection of consumers goods and the goods manufacturers delivered to their clients.”
                </p>
              </div>
            </div>
          </div>
        </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'reasons',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/reasons.scss";
  </style>
  